import { render, staticRenderFns } from "./AdminAlertSettings.vue?vue&type=template&id=40ee5b84&"
import script from "./AdminAlertSettings.vue?vue&type=script&lang=js&"
export * from "./AdminAlertSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports